import React, { FC } from 'react';
import s from './GaugeWithTable.module.scss';

interface ProgressLineProps {
  progressValue: number;
  status: 'Yes' | 'No';
}

const ProgressLine: FC<ProgressLineProps> = ({ progressValue, status }) => {
  const color = status === 'No' ? '#EBEEF2' : '#52B36B';

  return (
    <div className={s.progressBar}>
      {progressValue > 0 && (
        <div
          className={s.progressBar__line}
          style={{ width: `${progressValue}%`, background: color }}
        />
      )}
    </div>
  );
};

export default ProgressLine;
